import type { RecommendationDisassociateButtonProps } from "./recommendation-disassociate-button.type";

import { DisconnectOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useObservationUpdate } from "@/entities/observation";

const invalidateKeys = [["observations"]];

const RecommendationDisassociateButton = ({
  observation,
  disabled = false,
}: RecommendationDisassociateButtonProps) => {
  const { t } = useTranslation();
  const title = t("recommendation:disassociate.label");

  const { updateObservation, isPending: isLoading } = useObservationUpdate(
    observation.id,
    { invalidateKeys }
  );

  const onDisassociate = () => {
    updateObservation({ recommendation_id: null });
  };

  return (
    <Button
      key="disassociate"
      icon={<DisconnectOutlined />}
      onClick={onDisassociate}
      title={title}
      aria-label={title}
      loading={isLoading}
      disabled={disabled}
    />
  );
};

export default RecommendationDisassociateButton;
